import { css } from '@emotion/css';

import { borderRadiusUI } from 'ms-styles/base';

export const sharedStyles = {
  labelWrapper: css({
    display: 'flex',
    alignItems: 'center',
    gap: 2,
    borderRadius: borderRadiusUI,
    height: 26,
    paddingRight: 6,
    paddingLeft: 6,
  }),
};
